import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { MapPinIcon, MailIcon, GlobeIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 bg-white scroll-mt-24" data-id="element-66">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-68">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-serif font-medium text-teal-900 mb-4" data-id="element-69">
            {t.contact.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-70">
            {t.contact.subtitle}
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16" data-id="element-71">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-72">
            <div className="bg-teal-50/50 rounded-2xl p-8 border border-teal-100/50" data-id="element-73">
              <div className="space-y-6" data-id="element-74">
                <div className="flex items-start space-x-4" data-id="element-75">
                  <div className="bg-white p-3 rounded-xl text-teal-600 shadow-sm" data-id="element-76">
                    <MapPinIcon size={24} data-id="element-77" />
                  </div>
                  <div data-id="element-78">
                    <h4 className="text-sm font-medium text-slate-500 mb-1" data-id="element-79">
                      Location
                    </h4>
                    <p className="text-lg text-slate-800" data-id="element-80">
                      {t.contact.info.location}
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-81">
                  <div className="bg-white p-3 rounded-xl text-teal-600 shadow-sm" data-id="element-82">
                    <GlobeIcon size={24} data-id="element-83" />
                  </div>
                  <div data-id="element-84">
                    <h4 className="text-sm font-medium text-slate-500 mb-1" data-id="element-85">
                      Online
                    </h4>
                    <p className="text-lg text-slate-800" data-id="element-86">
                      {t.contact.info.virtual}
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-87">
                  <div className="bg-white p-3 rounded-xl text-teal-600 shadow-sm" data-id="element-88">
                    <MailIcon size={24} data-id="element-89" />
                  </div>
                  <div data-id="element-90">
                    <h4 className="text-sm font-medium text-slate-500 mb-1" data-id="element-91">
                      Email
                    </h4>
                    <a href={`mailto:${t.contact.info.email}`} className="text-lg text-teal-600 hover:text-teal-700 transition-colors" data-id="element-92">
                      {'thehopecircle.ase@gmail.com'}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-93">
                  <div className="bg-white p-3 rounded-xl text-teal-600 shadow-sm" data-id="element-94">
                    <PhoneIcon size={24} data-id="element-95" />
                  </div>
                  <div data-id="element-96">
                    <h4 className="text-sm font-medium text-slate-500 mb-1" data-id="element-97">
                      Phone
                    </h4>
                    <p className="text-lg text-slate-800" data-id="element-98">+64(0)273737738</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-99">
            <form className="space-y-6 bg-white rounded-2xl p-8 shadow-sm border border-slate-100" onSubmit={e => e.preventDefault()} data-id="element-100">
              <div data-id="element-101">
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-102">
                  {t.contact.form.name}
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all" placeholder="Jane Doe" data-id="element-103" />
              </div>

              <div data-id="element-104">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-105">
                  {t.contact.form.email}
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all" placeholder="jane@example.com" data-id="element-106" />
              </div>

              <div data-id="element-107">
                <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-108">
                  {t.contact.form.message}
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all resize-none" placeholder="..." data-id="element-109"></textarea>
              </div>

              <button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 text-white px-6 py-3.5 rounded-xl font-medium transition-colors shadow-sm" data-id="element-110">
                {t.contact.form.submit}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}